<template>
  <div class="news-center">
    <div class="us_header">
      <div class="title_main">
        <!-- <div class="title_line"></div> -->
        <div class="zh_title">最新热点新闻</div>
        <div class="eg_title">与你分享最新鲜的政策动态、 行业资讯</div>
      </div>
    </div>
    <div class="new-content">
      <div class="new-type">
        <div
          v-for="(item, index) in title"
          class="tab-control-item"
          :key="index"
          :class="{ active: item.id === currentIndex }"
          @click="itemClick(item)"
        >
          <div >{{ item.name }}</div>
        </div>
      </div>
      <div class="new-detail">
        <!-- <router-view></router-view> -->
        <news-list :type='type' ref="newsList"></news-list>
      </div>
    </div>
    <left-float-btn></left-float-btn>
  </div>
</template>
<script>
import newsList from './newsList.vue'
import LeftFloatBtn from "../../../components/LeftFloatBtn";
export default {
  name: "newsCenter",
  components: {
      LeftFloatBtn,
    newsList
  },
  data() {
    return {
      currentIndex: 0,
      title: [],
      type:'',
       time1:null,
      time2:null,
    };
  },

  mounted() {
    this.getColumn();
    if(this.$route.query.type){
      this.type=this.$route.query.type
         this.currentIndex = this.$route.query.type
        this.time1=setTimeout(() => {
          this.$refs.newsList.getdetail().then(()=> this.time1=null)
      }, 0);
    }
  },
  methods: {
    itemClick(item) {
      // this.$router.push({
      //   path: "/newsCenter",
      //   query: { type: item.id },
      // });
      this.type=item.id
      this.currentIndex = item.id;
     this.time1=setTimeout(() => {
          this.$refs.newsList.getdetail().then(()=> this.time1=null)

      }, 0);
    },
    async getColumn() {
      const res = await this.API.operateManage.getPortalNewsChannelsFn();
      if (res.code == 200) {
        this.title = res.data;
         if(!this.$route.query.type){
            this.currentIndex = this.title[0].id;
            this.type=this.title[0].id
            this.time2=setTimeout(() => {
              this.$refs.newsList.getdetail().then(()=> this.time2=null)
            }, 0);
         }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.news-center {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .new-detail {
    width: 900px;
    border-radius: 6px;
    margin-left: 16px;
  }
}
.new-content {
  width: 100%;
  background: #f5f7fd;
  display: flex;
  justify-content: center;
  margin-top: 35px;
  padding: 0px 10%;
  margin-bottom: 20px;
}
.us_header {
  background: url("../../../assets/image/newsNewsCenter.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 660px;
  position: relative;

  .title_main {
    position: absolute;
    left: 18.7%;
    top: 252px;

    .title_line {
      width: 68px;
      height: 8px;
      background: #ffffff;
      opacity: 1;
    }

    .zh_title {
      font-family: "Microsoft YaHei Bold";
      font-weight: 700;
      font-size: 38px;
      text-align: left;
      color: #16181a;

      margin-top: 25px;
      margin-bottom: 18px;
    }

    .eg_title {
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 18px;
      color: #000;
      margin-top: 42px;
    }
  }
}
.new-type {
  width: 16%;
  min-height: 194px;
  background: #ffffff;
  opacity: 1;
  height: 100%;
  border-radius: 6px;
  .tab-control-item {
    // padding-top: 5px;
    cursor: pointer;
  }
  .tab-control-item div {
    // margin-top: 10px;
    min-height: 42px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 8px 12px;
    font-family: Microsoft YaHei;

    color: #16181a;
  }
  div :hover {
    background: rgba(0, 82, 217, 0.1);
    color: rgba(0, 82, 217, 1);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 600;
  }
  .active div {
    background: rgba(0, 82, 217, 0.1);
    color: rgba(0, 82, 217, 1);
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 600;
  }
}
</style>
